import {Injectable} from "@angular/core";
import {ApiService} from "../../../shared/services/api.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {applicationUrls} from "../../../shared/application-constants/application-urls.const";

@Injectable({
  providedIn: 'root'
})
export class AssessorsDashboardService {


  constructor(private apiService: ApiService, private http: HttpClient,
  ) {

  }


  getAssessorsDashboardDetails(userId: any): Observable<any> {
    const url = `${applicationUrls.commonService.getAssessorsDashboardDetails}/` + userId;
    return this.apiService.get(url);
  }

  readBlockUnblockData(): Observable<any> {
    const url = `${applicationUrls.commonService.readAssessorBlockUnblockData}`;
    return this.apiService.get(url);
  }

}
